import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { string, arrayOf, object } from 'prop-types';
import ListingItem from 'components/filtered-listing/items/ListingItem';

export default function TileContainer({ items, columnClass, tileWrap, tileType }) {
    return (
        <ReactCSSTransitionGroup
            component="div"
            className={`fl-tile-container ${columnClass} ${tileWrap}`}
            transitionName="fade-in-out"
            transitionAppear={true}
            transitionAppearTimeout={200}
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
        >
            <div className="row">
                {items.map((item, index) => (
                    <ListingItem
                        /* eslint-disable react/no-array-index-key */
                        // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                        //         keep using index for now until we find a better solution
                        key={index}
                        item={item}
                        tileType={tileType}
                        /* eslint-enable react/no-array-index-key */
                    />
                ))}
            </div>
        </ReactCSSTransitionGroup>
    );
}

TileContainer.propTypes = {
    items: arrayOf(object).isRequired,
    columnClass: string.isRequired,
    tileType: string.isRequired,
    tileWrap: string.isRequired
};
